import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pixi: {
    isAssetsLoaded: false,
    isInitialized: false
  }
}

const shortDeckSlice = createSlice({
  name: 'shortDeck',
  initialState,
  reducers: {
    setPixiAssetsLoaded: (state, action) => {
      state.pixi.isAssetsLoaded = action.payload
    },
    setPixiInitialized: (state, action) => {
      state.pixi.isInitialized = action.payload
    }
  }
})

export const {
  setPixiAssetsLoaded,
  setPixiInitialized
} = shortDeckSlice.actions

export default shortDeckSlice.reducer
